import { CouponCodeBackendModel, CouponCodeModel } from './coupon.model';
import { UserBackendListModel, UserModel } from './user.model';

export type InvoiceModel = {
  id: number;
  type: InvoiceTypeEnum;
  invoiceNr: string;
  bookingId: number;
  bookingNr: string;
  facility?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  street: string;
  streetNr: string;
  zip: string;
  city: string;
  country: string;
  paymentMethod: string;
  paymentStatus: string;
  discountedAmount: number;
  totalAmount: number;
  generatedAt: string;
  creator: UserModel;
  seminar?: {
    id: number;
    title: string;
    seminarNr: string;
  };
  coupons?: CouponCodeModel[];
  positions?: {
    id: number;
    position: number;
    title: string;
    price: number;
    quantity: number;
    total: number;
  }[];
};

export type InvoiceListModel = {
  id: number;
  email: string;
  type: InvoiceTypeEnum;
  creator: UserModel;
  seminarTitle: string;
  invoiceNr: string;
  paymentStatus: string;
  generatedAt: Date;
};

export type InvoiceBackendModel = {
  id: number;
  type: InvoiceTypeEnum;
  invoice_nr: string;
  id_booking: number;
  booking_nr: string;
  facility?: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  street: string;
  street_nr: string;
  zip: string;
  city: string;
  country: string;
  payment_method: string;
  payment_status: string;
  total_amount: number;
  discounted_amount: number;
  generated_at: string;
  creator: UserBackendListModel;
  seminar?: {
    id: number;
    title: string;
    seminar_nr: string;
  };
  coupons?: CouponCodeBackendModel[];
  positions?: {
    id: number;
    position: number;
    title: string;
    price: number;
    quantity: number;
    total: number;
  }[];
};

export type InvoiceBackendListModel = {
  id: number;
  email: string;
  type: InvoiceTypeEnum;
  creator: UserBackendListModel;
  seminar_title: string;
  invoice_nr: string;
  payment_status: string;
  generated_at: string;
};

export enum InvoiceTypeEnum {
  BOOKING = 'booking',
  COUPON = 'coupon',
  CANCELLATION = 'cancellation',
}
